var $87f92a7e077514b2$exports = {};
$87f92a7e077514b2$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Nie zaznaczono ".concat(args.item, ".");
  },
  "longPressToSelect": "Naci\u015Bnij i przytrzymaj, aby wej\u015B\u0107 do trybu wyboru.",
  "select": "Zaznacz",
  "selectedAll": "Wszystkie zaznaczone elementy.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nie zaznaczono \u017Cadnych element\xF3w",
      one: function one() {
        return "".concat(formatter.number(args.count), " zaznaczony element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " zaznaczonych element\xF3w");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Zaznaczono ".concat(args.item, ".");
  }
};
export { $87f92a7e077514b2$exports as default };